import type { Store } from 'effector'
import type { ModuleFallbackFlags } from './index.h'

import { api } from '@setplex/tria-api'
import { createStore } from 'effector'
import { pick } from './lib'

export const $visibility = createStore<ModuleFallbackFlags>({})
  .on(api.session.signInFx.doneData, (ops, { payload }) => pick(payload, ops))
  .on(api.session.guestInFx.doneData, (ops, { payload }) => pick(payload, ops))
  .on(api.session.getAccountFx.doneData, (ops, session) => pick(session, ops))
  .reset(api.session.signOutFx.finally)

// options getter
export const get = <K extends keyof ModuleFallbackFlags>(
  name: K,
  def: NonNullable<ModuleFallbackFlags[K]>
): Store<NonNullable<ModuleFallbackFlags[K]>> =>
  $visibility.map((modules) => modules[name] ?? def)

export const $vodEnabled = get('vodEnabled', false)
export const $tvEnabled = get('tvEnabled', false)
export const $tvShowEnabled = get('tvShowEnabled', false)
export const $liveEventEnabled = get('liveEventEnabled', false)
